module.exports = __webpack_public_path__ + "img/Twizzlers.5b968d0e.webp";